import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
	ServerDataResponse,
	ShootProofGalleriesBrand,
	ShootProofGalleriesBrandSelected,
	shootProofSettingsToIntegrate,
	shootProofSettingsToUpdate
} from '../../../models/models';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class ShootProofDataProvider {
	constructor(private http: HttpClient) {}

	initShootProofIntegrationV1(): Observable<any> {
		const url = '/api/user/v1/shootproof/authentication';
		return this.http.get(url);
	}

	disconnectShootProofV1(): Observable<any> {
		const url = '/api/user/v1/shootproof/integration';
		return this.http.delete(url);
	}

	setShootProofSettingsV1(
		settings: shootProofSettingsToIntegrate
	): Observable<any> {
		const url = '/api/user/v1/shootproof/integration';
		return this.http.post(url, settings);
	}

	updateShootProofSettingsV1(
		settings: shootProofSettingsToUpdate
	): Observable<any> {
		const url = '/api/user/v1/shootproof/integration';
		return this.http.put(url, settings);
	}

	getExistingShootProofSettingsV1(): Observable<any> {
		const url = '/api/user/v1/shootproof/integration';
		return this.http.get(url);
	}

	// SHOOTPROOF GALERIES
	getJobGalleriesV1(jobId: number): Observable<any> {
		const url = `/api/user/v1/job/${jobId}/gallery`;
		return this.http.get(url);
	}

	removeJobGalleryV1(
		galleryId: number,
		removeFromShootProof = false
	): Observable<ServerDataResponse<null>> {
		const url = `/api/user/v1/shootproof/gallery/${galleryId}?removeFromShootProof=${removeFromShootProof}`;
		return this.http.delete<ServerDataResponse<null>>(url);
	}

	getBrandsForGalleriesV1(): Observable<
		ServerDataResponse<ShootProofGalleriesBrand[]>
	> {
		const url = '/api/user/v1/shootproof/brand';
		return this.http.get<ServerDataResponse<ShootProofGalleriesBrand[]>>(url);
	}

	getGalleriesToImportV1(
		shootProofBrandId: number
	): Observable<ServerDataResponse<ShootProofGalleriesBrandSelected[]>> {
		const url = `/api/user/v1/shootproof/gallery?brandId=${shootProofBrandId}`;
		return this.http.get<
			ServerDataResponse<ShootProofGalleriesBrandSelected[]>
		>(url);
	}

	selectExistingGaleryV1(galleryDetails): Observable<any> {
		const url = '/api/user/v1/shootproof/gallery/import';
		return this.http.post(url, galleryDetails);
	}

	getGalleryPresetsV1(shootProofBrandId: number) {
		const url = `/api/user/v1/shootproof/gallery-preset?brandId=${shootProofBrandId}`;
		return this.http.get(url);
	}

	createShootProofNewGalleryFromSNV1(galleryDetails: any): Observable<any> {
		const url = '/api/user/v1/shootproof/gallery/create';
		return this.http.post(url, galleryDetails);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/integrations/shootProof/shootProof.data.service.ts